import { type ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import NoItemIcon from 'src/assets/icons/NoItemIcon';
import CustomTitleBar from 'src/components/GuideMeTitleBar';
import Button from 'src/components/design-system/Button';

/** Ignores Trans-injected children so the icon always renders. */
const GuideNoItemIcon = (_props: { children?: ReactNode }) => (
  <span className="inline-flex align-middle">
    <NoItemIcon width="18" height="18" />
  </span>
);

const ShoppingCartContent = () => {
  const { t } = useTranslation();

  return (
    <ul className="space-y-1 px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">{t('shoppingCartGuide.showsSuppliersAndItems')}</li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="shoppingCartGuide.supplierCardInfo"
          components={{
            supplierInfo: (
              <button
                type="button"
                className="pointer-events-none p-0 font-semibold leading-none text-info"
                tabIndex={-1}
              />
            ),
          }}
        />
      </li>
      <li className="list-disc font-semibold">{t('shoppingCartGuide.selectCheckboxCreatePo')}</li>
      <li className="list-disc font-semibold">{t('shoppingCartGuide.filterBar')}</li>
      <li className="list-disc font-semibold">{t('shoppingCartGuide.qtyAutoSave')}</li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="shoppingCartGuide.contractedAlternatives"
          components={{
            noItemIcon: <GuideNoItemIcon />,
          }}
        />
      </li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="shoppingCartGuide.deleteItems"
          components={{
            deleteButton: (
              <Button color="error" size="md" className="inline-block" readonly>
                {null}
              </Button>
            ),
          }}
        />
      </li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="shoppingCartGuide.createPoForSelected"
          components={{
            createPoButton: (
              <Button color="success" size="md" className="inline-block" readonly>
                {null}
              </Button>
            ),
          }}
        />
      </li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="shoppingCartGuide.reviewAlternatives"
          components={{
            reviewButton: (
              <Button color="info" size="md" className="inline-block" readonly>
                {null}
              </Button>
            ),
          }}
        />
      </li>
    </ul>
  );
};

const useShoppingCartGuideMeSteps = () => {
  const { t } = useTranslation();

  return [
    {
      title: (
        <CustomTitleBar
          title={t('shoppingCartGuide.title')}
          className="font-bold text-xl text-red-600 max-[425px]:text-base max-[425px]:leading-snug"
        />
      ),
      content: <ShoppingCartContent />,
    },
  ];
};

export default useShoppingCartGuideMeSteps;
